import _ from 'lodash';
import {
  setCurrentUser,
  setCurrentPortal,
  setCurrentCohort,
  setCurrentCourse,
  setCurrentUserAccess,
} from './dispatchers';
import { dataLoader, dataMultiLoader } from '../../web/utilities/dataLoader';

export function initialise(dispatch) {
  const currentUserData = dataLoader('current-user-id-data');
  const currentPortal = dataMultiLoader('current-portal-name');
  const currentUser = _.isEmpty(currentUserData) ? null : currentUserData;
  const currentUserAccess = dataLoader('current-user-access');

  dispatch(setCurrentUser(currentUser));
  if (currentPortal.length) {
    dispatch(setCurrentPortal(currentPortal[0]));
  }
  if (window.currentCohort) {
    dispatch(setCurrentCohort(window.currentCohort));
  }
  if (window.currentCourse) {
    dispatch(setCurrentCourse(window.currentCourse));
  }

  if (Object.keys(currentUserAccess).length > 0) {
    // Side effect of using json_js filter on empty dict in data.html
    if (currentUserAccess.courseRoles === '') {
      currentUserAccess.courseRoles = {};
    }
    if (currentUserAccess.classRoles === '') {
      currentUserAccess.classRoles = {};
    }

    dispatch(setCurrentUserAccess(currentUserAccess));
  }
}
